module.exports = __webpack_public_path__ + "static/prostate-risks-c040ff5298cd4630566a1d71e2bc9261.png";